var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUaelang(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1660_884)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    rx: 7.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-8 -4H24V20H-8V-4Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-8 -4V4H24V-4H-8Z",
    fill: "#5EAA22"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-8 12V20H24V12H-8Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -8,
    y: -4,
    width: 10,
    height: 24,
    fill: "#E31D1C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1660_884"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    rx: 7.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUaelang);
export default __webpack_public_path__ + "static/media/uaelang.87fce2d1594b2ab0784aaa0e0ae2d011.svg";
export { ForwardRef as ReactComponent };